import {FC} from 'react';
import {Box, Drawer, Typography} from '@mui/material';
import Input from '@/shared/components/Inputs/Input';
import {H5} from '@/utils/constants';
import {ReactComponent as DollarIcon} from '@icons/dollar-circle.svg';
import {addDonationModalStyle} from './AddDonationModal.styles';
import Button from '@/shared/components/Button';
import {ReactComponent as LeftIcon} from '@icons/arrow-left.svg';

interface MakeDonationModalProps {
	value: string;
	setValue: (value: string) => void;
	bidderId?: string;
	setBidderId?: (value: string) => void;
	error?: string;
	onClose?: () => void;
	addDonation?: () => void;
}

const AddDonation: FC<MakeDonationModalProps> = ({
	value,
	setValue,
	bidderId,
	setBidderId,
	error,
	onClose,
	addDonation,
}) => {
	return (
		<Box sx={addDonationModalStyle.wrapper}>
			<Box sx={addDonationModalStyle.container}>
				<LeftIcon onClick={onClose} />
				<Typography sx={addDonationModalStyle.headerTitle}>Add Donation</Typography>
			</Box>
			<Typography variant={H5} sx={addDonationModalStyle.title}>
				Donation
			</Typography>

			<Box sx={addDonationModalStyle.itemList}>
				<Box sx={addDonationModalStyle.search}>
					<DollarIcon />
					<Input
						fullWidth
						placeholder="0"
						value={value}
						onChange={setValue}
						label="Enter your custom amount"
						disableErrorMessage={false}
						errorMessage={error}
						type="number"
					/>
				</Box>
				<Box sx={addDonationModalStyle.search}>
					<DollarIcon />
					<Input
						fullWidth
						placeholder="Enter bidder number"
						value={bidderId}
						onChange={setBidderId}
						label="Bidder number"
						disableErrorMessage={false}
						errorMessage={error}
						type="number"
					/>
				</Box>
			</Box>
			<Drawer variant="permanent" anchor="bottom" sx={addDonationModalStyle.drawer}>
				<Box sx={addDonationModalStyle.popup}>
					<Button title="Add Donation" onClick={addDonation} disabled={!value || !bidderId} />
				</Box>
			</Drawer>
		</Box>
	);
};

export default AddDonation;
